<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/hero-img.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-containt position-relative">
            <h3>404 - Page not found...</h3>
            <img src="assets/img/u.png" alt="" />

            <p></p>
            <img src="assets/img/logo_emerging.png" alt="" width="200" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
export default {
  data() {
    return {
      textElements: {}
    };
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}
</style>
